import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const AccountsPage = () => {
  // Accounts data
  const accountsData = [
    { year: "2021-22", file: "/pdf/Accounts2022.pdf", status: "available" },
    { year: "2020-21", file: "/pdf/Accounts2021.pdf", status: "available" },
    { year: "2019-20", file: "/pdf/Accounts2020.pdf", status: "available" },
    { year: "2018-19", file: "#", status: "pending", note: "Pending From CA" },
    { year: "2017-18", file: "/pdf/Accounts2018.pdf", status: "available" },
    { year: "2016-17", file: "/pdf/Accounts2017.pdf", status: "available" },
    { year: "2015-16", file: "/pdf/Accounts2016.pdf", status: "available" },
    { year: "2014-15", file: "/pdf/Accounts2015.pdf", status: "available" },
    { year: "2013-14", file: "/pdf/Accounts2014.pdf", status: "available" },
    { year: "2012-13", file: "/pdf/Accounts2013.pdf", status: "available" },
    { year: "2011-12", file: "/pdf/Accounts2012.pdf", status: "available" }
  ];

  useEffect(() => {
    document.title = 'Account | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
  }, []);

  return (
    <div id="outer_m">
      <PublicHeader />

      {/* Main Content */}
      <div id="main">
        {/* Social Media Sticky Icons */}
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
        </div>

        <Link to="/rti">
          <div id="stick_right"></div>
        </Link>

        {/* Accounts Content */}
        <br /><br /><br />

        <div className="col-lg-6 col-sm-offset-3">
          <div className="panel panel-default">
            <div className="panel-heading">
              <h3 className="heading3">Accounts</h3>
            </div>
            <div className="panel-body">
              {accountsData.map((account, index) => (
                <div key={index}>
                  <p className="depart_pboth">
                    {account.status === 'available' ? (
                      <a href={account.file} target="_blank" rel="noopener noreferrer">
                        <i className="fa fa-angle-double-right" style={{fontSize: '24px', color: '#0076a3'}}></i>
                        {' '}Account for FY {account.year}
                      </a>
                    ) : (
                      <a href={account.file}>
                        <i className="fa fa-angle-double-right" style={{fontSize: '24px', color: '#0076a3'}}></i>
                        {' '}Account for FY {account.year} - {account.note}
                      </a>
                    )}
                  </p>
                  {index < accountsData.length - 1 && <hr />}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <PublicFooter />
    </div>
  );
};

export default AccountsPage;